import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'atsFilterByID',
    standalone: false
})
export class AtsFilterByIdPipe implements PipeTransform {
	transform(values: any[], id: number | string): any {
		return values.filter(val => val.id === id);
	}
}
